/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react'
import { ContentComponentType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/ContentComponentType'
import { useIssueTemporaryPasswordMutation } from '../../graphql/graphql'
import {
  DEFAULT_CLASS_NAME,
  DEFAULT_LABEL_CLASS_NAME
} from '../../constants/constants'

export function TemporaryPassword({
  currentState,
  doSubmit,
  clearState
}: ContentComponentType) {
  const [email, setEmail] = useState(currentState?.email)
  const [localDoSubmit, setLocalDoSubmit] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [tempPassword, setTempPassword] = useState('')
  const [issueTemporaryPasswordMutation] = useIssueTemporaryPasswordMutation()
  const [emailHasChanged, setEmailHasChanged] = useState(false)

  useEffect(() => {
    if (currentState.email !== email) {
      setEmail(currentState.email)
      setEmailHasChanged(true)
    }
  }, [email, currentState.email])

  const submit = useCallback(async () => {
    try {
      if (emailHasChanged) {
        setSubmitted(false)
        setSubmitting(true)
        const { data }: any = await issueTemporaryPasswordMutation({
          variables: {
            username: email
          },
          onError: (err) => {
            const message = err.message.search('Must be in email format')
            if (message >= 0) {
              alert('Please provide a value with a valid email format')
            } else {
              alert(err.message)
            }
          }
        })
        setTempPassword(data.issueTemporaryPassword?.tempPassword)
        setSubmitting(false)
        setSubmitted(true)
      }
    } catch (error) {
      setTempPassword('')
      setSubmitting(false)
      setSubmitted(true)
    } finally {
      clearState()
    }
  }, [email, emailHasChanged, issueTemporaryPasswordMutation, clearState])

  const btn = (label = 'Generate Temporary Password') => (
    <button
      type="button"
      className="mt-20 btn btn-primary"
      onClick={submit}
      disabled={submitting || !email}
    >
      {label}
    </button>
  )

  useEffect(() => {
    if (doSubmit && !localDoSubmit) {
      setLocalDoSubmit(true)
      submit()
    }
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit, submit])

  useEffect(() => {
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit])

  if (submitting) {
    return <div className="pt-20">Generating temp password...</div>
  }
  if (submitted && email && emailHasChanged && !tempPassword) {
    return (
      <div className="pt-20">
        Failed to generate temp password for {email}
        <br />
        {btn('Retry')}
      </div>
    )
  }
  if (submitted && tempPassword) {
    return (
      <>
        <div>{btn('Generate Another Temporary Password')}</div>
        <div className="row pt-20">
          <div className="col-12">
            User {email} temporary password was successfully generated
            <br />
            <div className="pt-20">
              <label className={DEFAULT_LABEL_CLASS_NAME}>Temp password:</label>
              <input
                name="login"
                type="text"
                className={DEFAULT_CLASS_NAME}
                value={tempPassword || ''}
                readOnly
              />
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="pt-20">
      Please enter username to set a temporary password.
      <br />
      {btn()}
    </div>
  )
}
